<template>
  <div class="h-full">
    <div class="topBarButtonsContainer flex justify-end py-3 pr-4">
      <div>
        <zt-button
          data-vs-button="reject-doc"
          class=" button text-base"
          outlined
          :disabled="
            approveLoadData.loading || approveLoadData.approved ? true : false
          "
          @click="rejectLoad"
          gtmClass="zt-gtm-documents-inbox-reject-ind"
        >
          {{
            this.$t("message.uploadImageComponent.topBar.rejectButton")
          }}</zt-button
        >
      </div>
      <div>
        <div
          v-if="approveLoadData.loading || approveLoadData.approved"
          class="statesButton flex items-center justify-center h-10"
          :class="{
            loading: approveLoadData.loading,
            approved: approveLoadData.approved,
          }"
        >
          <div v-if="approveLoadData.loading" class="loader"></div>
          <div v-else><zt-icon name="check" /></div>
        </div>
        <zt-button
          data-vs-button="approved-doc"
          v-else
          class="button text-base"
          outlined
          @click="approveLoad"
          gtmClass="zt-gtm-documents-inbox-approve-ind"
          >{{
            this.$t("message.uploadImageComponent.topBar.approveButton")
          }}</zt-button
        >
      </div>
    </div>
    <div
      class="visualizerContainer flex flex-wrap bg-viewer justify-center items-center relative"
    >
      <div class="h-16 w-full bg-top-bar">
        <div class="w-full h-full flex">
          <div class="w-left-bar m-auto">
            <button
              data-vs-button="fit-to"
              class="zt-gtm-documents-inbox-fit-to-viewport pl-10"
              @click="fitToScreen"
            >
              <zt-icon class="text-zt-xl" name="expand-outline pointer-events-none" />
            </button>
          </div>
          <div class="w-right-bar flex m-auto">
            <div class="degreeProfileAndFileContent pr-3">
              {{
                this.$t(
                  "message.uploadImageComponent.body.rightContainer.employeeInfo.pages"
                )
              }}
              {{ this.documents.initialPagesDocs }} de
              {{ this.documents.totalPagesDocs }}
            </div>
            <div>
              <button
                data-vs-button="change-page"
                class="angle-page"
                @click="changePageDocuments('left')"
                :disabled="
                  this.loading === true ||
                    (this.documents.attached.initialAttach === 1 &&
                      this.documents.image.page === 1)
                "
              >
                <zt-icon name="angle-left" />
              </button>
            </div>
            <div>
              <button
                data-vs-button="change-angle"
                class="angle-page"
                @click="changePageDocuments('right')"
                :disabled="
                  this.loading === true ||
                    (this.documents.attached.initialAttach ===
                      this.documents.attached.maxAttach &&
                      this.documents.image.page ===
                        this.documents.image.totalPages)
                "
              >
                <zt-icon name="angle-right" />
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="visualizerDocument" v-if="loading">
        <vue-element-loading
          background-color="rgba(70, 70, 70, 0.8)"
          :active="loading"
          spinner="spinner"
          duration="1.0"
          color="#FFFFFF"
          size="50"
          :text="
            $t('message.uploadImageComponent.body.rightContainer.image.loading')
          "
          id="loadingForFixing"
        />
      </div>
      <div
        v-if="isDocumentInit"
        id="containerZoom"
        class="visualizerDocument"
      >
        <div
          id="itemZoom"
          class="documentProperties"
          :class="breakpointDocClass"
          :style="
            'background-image: url(' +
              documents.image.imageRender +
              '); transform: scale(' +
              documents.zoomVariableOnDoc / 100 +
              '); '
          "
        ></div>
      </div>
      <div
        class="problemWithImageText visualizerDocument"
        v-else-if="documents.image.errorOnPage && loading === false"
      >
        {{
          this.$t(
            "message.uploadImageComponent.body.rightContainer.image.problemWithImage"
          )
        }}
      </div>

      <div
        class="flex flex-wrap w-16 absolute"
        :class="
          breakpointLg ? 'zoom-buttons-position-lg' : 'zoom-buttons-position'
        "
      >
        <zt-button
          data-vs-button="zoom-in"
          class="mb-2"
          color="dark-100"
          icon="plus-2"
          fab
          outlined
          @click="activateZoom('sum')"
          gtmClass="zt-gtm-documents-inbox-zoom-in"
        ></zt-button>
        <zt-button
          data-vs-button="zoom-out"
          class="mt-2"
          color="dark-100"
          icon="minus"
          fab
          outlined
          @click="activateZoom('minus')"
          gtmClass="zt-gtm-documents-inbox-zoom-out"
        ></zt-button>
      </div>
    </div>
  </div>
</template>

<script>
import User from "../../apiClient/Employee";
import VueElementLoading from "vue-element-loading";
import { useWindowResize } from "@sichern/ui-elements";

export default {
  props: ["user", "approveLoadData", "rejectLoadData"],
  components: {
    VueElementLoading,
  },
  data() {
    return {
      UserApi: User,
      loading: false,
      documents: {
        zoomVariableOnDoc: 100,
        optionsForZoom: {
          40: 40,
          60: 60,
          80: 80,
          100: 100,
          120: 120,
          140: 140,
          160: 160,
          180: 180,
          200: 200,
        },
        attached: {
          initialAttach: 1,
          maxAttach: 0,
        },
        image: {
          errorOnPage: false,
          imageRender: "",
          page: 1,
          totalPages: undefined,
        },
        totalPagesDocumentPrevious: [],
        initialPagesDocs: 1,
        totalPagesDocs: 0,
      },
      windowResize: useWindowResize(this),
    };
  },
  created() {
    this.UserApi = new User();
    this.loading = true;
    this.getTotalPagesDocs();
    this.getTotalPages();
    this.getDocumentView();
  },
  updated() {
    this.preventLoading();
  },
  watch: {
    "documents.attached.initialAttach": function() {
      this.getDocumentView();
      this.getTotalPages();
    },
    "documents.image.page": function() {
      this.getDocumentView();
      this.getTotalPages();
    },
  },
  computed: {
    breakpointDocClass: function() {
      if (this.windowResize.width < 1280 && this.windowResize.width >= 1024) {
        return "docSizeLg";
      } else if ( this.windowResize.width < 1024 && this.windowResize.width < 769) {
        return "docSizeMd";
      } else {
        return "docSizeXl";
      }
    },
    breakpointLg: function() {
      return this.windowResize.width < 1024 && this.windowResize.width >= 769;
    },
    isDocumentInit() {
      return this.documents.image.errorOnPage === false && this.loading === false
    }
  },
  methods: {
    preventLoading() {
      if (
        this.documents.attached.initialAttach >= 1 &&
        this.documents.image.page >= 1
      ) {
        this.loading = false;
      }
    },
    approveLoad() {
      this.$emit('approveLoad', 'individual', {
        approveId: this.user.id_carga,
        type: this.user.id_type_flows
      })
    },
    rejectLoad() {
      this.$emit('openModalAndSaveRejectData', {
        rejectId: this.user.id_carga,
        type: this.user.id_type_flows,
        document: this.user.nombre_tipo_documento
      })
    },
    getDocumentView() {
      this.loading = true;
      if (!this.user.template.hash) {
        this.UserApi.getDocUploadFiles(
          this.user.id_carga,
          this.user.template.files[this.documents.attached.initialAttach - 1]
            .hash,
          this.documents.image.page
        )
          .then((response) => {
            this.documents.image.errorOnPage = false;
            var data_uri_prefix = "data:image/*;base64,";
            var image = data_uri_prefix + response;
            this.documents.image.imageRender = image;
            this.loading = false;
            this.$nextTick(() => {
              this.getViewportSize();
              this.navigateZoom();
            })
          })
          .catch((error) => {
            this.documents.image.errorOnPage = true;
            this.loading = false;
          });
      } else {
        const idApp = this.user.template.idAppSICHERN;
        this.UserApi.getDocUploadFilesFromFS(
          idApp,
          this.user.template.iddoc,
          this.documents.image.page
        )
          .then((response) => {
            if (response.length > 0) {
              this.documents.image.errorOnPage = false;
              var data_uri_prefix = "data:image/*;base64,";
              var image = data_uri_prefix + response;
              this.documents.image.imageRender = image;
              this.loading = false;
              this.$nextTick(() => {
                this.getViewportSize();
                this.navigateZoom();
              })
            } else {
              this.documents.image.errorOnPage = true;
              this.loading = false;
            }
          })
          .catch(() => {
            this.documents.image.errorOnPage = true;
            this.loading = false;
          });
      }
    },
    getTotalPages() {
      this.loading = true;
      if (!this.user.template.hash) {
        this.UserApi.getDocumentPages(
          this.user.id_carga,
          this.user.template.files[this.documents.attached.initialAttach - 1]
            .hash
        )
          .then((response) => {
            this.loading = false;
            this.documents.image.totalPages = response.data.results.data[0];
          })
          .catch((error) => {
            this.documents.image.totalPages = 1;
            this.documents.image.errorOnPage = true;
            this.loading = false;
          });
      } else {
        const idApp = this.user.template.idAppSICHERN;
        this.UserApi.getDocumentPagesFromFS(idApp, this.user.template.iddoc)
          .then((response) => {
            this.loading = false;
            this.documents.image.totalPages = response.data.results.data[0];
          })
          .catch((error) => {
            this.documents.image.totalPages = 1;
            this.documents.image.errorOnPage = true;
            this.loading = false;
          });
      }
    },
    getTotalPagesDocs() {
      if (!this.user.template.hash) {
        for (let key in this.user.template.files) {
          this.UserApi.getDocumentPages(
            this.user.id_carga,
            this.user.template.files[key].hash
          )
            .then(async (response) => {
              this.documents.totalPagesDocs =
                this.documents.totalPagesDocs + response.data.results.data[0];
              this.documents.attached.maxAttach++;
            })
            .catch((error) => {
              this.documents.image.errorOnPage = true;
              this.loading = true;
            });
        }
      } else {
        const idApp = this.user.template.idAppSICHERN;
        this.UserApi.getDocumentPagesFromFS(idApp, this.user.template.iddoc)
          .then((response) => {
            this.documents.totalPagesDocs = response.data.results.data[0];
            this.documents.attached.maxAttach++;
          })
          .catch((error) => {
            this.documents.image.errorOnPage = true;
            this.loading = false;
          });
      }
    },
    changeAttachedDocument(direction) {
      if (direction === "left") {
        if (this.documents.attached.initialAttach > 1) {
          this.documents.image.page = 1;
          this.documents.attached.initialAttach--;
        }
      } else if (direction === "right") {
        if (
          this.documents.attached.initialAttach > 0 &&
          this.documents.attached.initialAttach !==
            this.documents.attached.maxAttach
        ) {
          this.documents.image.page = 1;
          this.documents.attached.initialAttach++;
        }
      }
    },
    changePageDocuments(direction) {
      if (direction === "right") {
        if (this.documents.attached.initialAttach > 0) {
          if (this.documents.image.page <= this.documents.image.totalPages) {
            this.documents.initialPagesDocs++;
            this.documents.image.page++;
          }
          if (this.documents.image.page > this.documents.image.totalPages) {
            this.saveTotalPagesDocumentPrevious();
            this.documents.attached.initialAttach++;
            this.documents.image.page = 1;
          }
        }
      }
      if (direction === "left") {
        if (
          this.documents.image.page <= this.documents.image.totalPages &&
          this.documents.attached.initialAttach >= 1
        ) {
          this.documents.initialPagesDocs--;
          this.documents.image.page--;
        }

        if (
          this.documents.image.page === 0 &&
          this.documents.attached.initialAttach > 1
        ) {
          this.documents.attached.initialAttach--;
          this.documents.image.page = this.documents.totalPagesDocumentPrevious[
            this.documents.attached.initialAttach - 1
          ];
          this.documents.totalPagesDocumentPrevious.splice(
            this.documents.attached.initialAttach - 1,
            1
          );
        }
      }
    },
    fitToScreen() {
      this.documents.zoomVariableOnDoc = 100;
    },
    activateZoom(parameter) {
      if (parameter == "sum" && this.documents.zoomVariableOnDoc < 200) {
        this.documents.zoomVariableOnDoc += 20;
      } else if (
        parameter == "minus" &&
        this.documents.zoomVariableOnDoc > 50
      ) {
        this.documents.zoomVariableOnDoc -= 20;
      }
    },
    navigateZoom(e) {
      let container = document.querySelector("#containerZoom");
      let activeItem = null;

      let active = false;

      container.addEventListener("touchstart", dragStart, false);
      container.addEventListener("touchend", dragEnd, false);
      container.addEventListener("touchmove", drag, false);

      container.addEventListener("mousedown", dragStart, false);
      container.addEventListener("mouseup", dragEnd, false);
      container.addEventListener("mousemove", drag, false);

      function dragStart(e) {
        if (e.target !== e.currentTarget) {
          active = true;

          activeItem = e.target;

          if (activeItem !== null) {
            if (!activeItem.xOffset) {
              activeItem.xOffset = 0;
            }

            if (!activeItem.yOffset) {
              activeItem.yOffset = 0;
            }

            if (e.type === "touchstart") {
              activeItem.initialX = e.touches[0].clientX - activeItem.xOffset;
              activeItem.initialY = e.touches[0].clientY - activeItem.yOffset;
            } else {
              activeItem.initialX = e.clientX - activeItem.xOffset;
              activeItem.initialY = e.clientY - activeItem.yOffset;
            }
          }
        }
      }

      function dragEnd(e) {
        if (activeItem !== null) {
          activeItem.initialX = activeItem.currentX;
          activeItem.initialY = activeItem.currentY;
        }

        active = false;
        activeItem = null;
      }

      function drag(e) {
        if (active) {
          if (e.type === "touchmove") {
            e.preventDefault();

            activeItem.currentX = e.touches[0].clientX - activeItem.initialX;
            activeItem.currentY = e.touches[0].clientY - activeItem.initialY;
          } else {
            activeItem.currentX = e.clientX - activeItem.initialX;
            activeItem.currentY = e.clientY - activeItem.initialY;
          }

          activeItem.xOffset = activeItem.currentX;
          activeItem.yOffset = activeItem.currentY;

          setTranslate(activeItem.currentX, activeItem.currentY, activeItem);
        }
      }
      let that = this;

      function setTranslate(xPos, yPos, el) {
        let zoom = that.documents.zoomVariableOnDoc / 100;
        el.style.transform =
          "scale(" + zoom + ") translate3d(" + xPos + "px, " + yPos + "px, 0)";
      }
    },
    changeDocument(direction) {
      if (
        direction === "right" &&
        this.documents.image.page < this.documents.image.totalPages
      ) {
        this.documents.image.page++;
      }
      if (direction === "left" && this.documents.image.page > 1) {
        this.documents.image.page--;
      }
    },
    saveTotalPagesDocumentPrevious() {
      this.documents.totalPagesDocumentPrevious.push(
        this.documents.image.totalPages
      );
    },
    getViewportSize() {
      const topBar = document.querySelector('.topBarButtonsContainer')
      const innerTopBar = document.querySelector('.bg-top-bar')

      const bboxTopBar = topBar.getBoundingClientRect()
      const bbBoxInnerTopBar = innerTopBar.getBoundingClientRect()

      document.querySelector('.visualizerContainer')
          .style.height = `calc(100% - ${bboxTopBar.height}px)`
      document.querySelector("#containerZoom")
          .style.height = `calc(100% - ${bbBoxInnerTopBar.height}px)`
    }
  },
};
</script>

<style scoped lang="scss">
@import "./public/assets/scss/_config.scss";

@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@-moz-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@-webkit-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@-ms-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@-o-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.velmld-overlay {
  background-color: #717171 !important;
  height: 2em;
  margin-top: 29em;
}

.topBarButtonsContainer .button {
  min-height: 2.5rem;
  color: #4f41a3 !important;
  margin-left: 0.5rem;
}

.topBarButtonsContainer .zt-button.button.zt-button-disabled-outline {
  color: rgba(0, 0, 0, 0.26) !important;
}

.topBarButtonsContainer .statesButton {
  width: 100px;
  border: 1px solid #4f41a3;
  border-radius: 5px;
  margin-left: 0.5rem;
}

.topBarButtonsContainer .statesButton.loading {
  background-color: #c4c4c4;
  border-color: #707070;
}

.topBarButtonsContainer .statesButton.statesButton.loading .loader {
  border: 1px solid #707070;
  border-top: 1px solid #c4c4c4;
  border-radius: 50%;
  width: 1.3rem;
  height: 1.3rem;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.topBarButtonsContainer .statesButton.approved {
  border-color: #54caa6;
  background-color: #54caa6;
  color: #ffffff;
}

.centerProfile {
  width: 33%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.attachedArrowContainer {
  width: 10%;
  &:hover {
    cursor: pointer;
  }
  &[disabled] {
    width: 10% !important;
    visibility: hidden !important;
    cursor: not-allowed !important;
  }
}

.changeAttachedArrow.icon-LeftChevron[disabled] {
  display: none;
}

.changeAttachedArrow.icon-RightChevron[disabled] {
  display: none;
}

.degreeProfileAndFile {
  display: flex;
  // width: 33%;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.degreeProfileAndFileTitle {
  color: $bluePrimary;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.degreeProfileAndFileContent {
  margin-top: 0.3em;
  color: $textSecondary;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.containerZoomPages {
  top: 90px;
  position: absolute;
  z-index: 0;
  justify-content: center;
  display: flex;
  align-items: center;
  flex-direction: column;
  right: 35%;
}

.navigateContainers {
  background-color: $white;
  display: flex;
  height: 1.6vw;
  border-radius: 3%;
}

.pagesToNavigateContainer {
  padding-top: 0.2vw;
  display: flex;
  color: $textPrimary;
  font-size: 0.8vw;
}

.borderHalfBoxdateHour {
  border: 0.5px solid rgba(0, 0, 0, 0.12);
}

.navigateContainers .icon-Add {
  font-size: 1.1vw;
  padding: 0.03em 0.2em;
}

.navigateContainers .icon-Add::before {
  color: $textPrimary;
}

.navigateContainers .icon-Subtraction {
  font-size: 1.1vw;
  padding: 0.03em 0.2em;
}

.navigateContainers .icon-Subtraction::before {
  color: $textPrimary;
}

.comboBoxZoom {
  background-color: $white;
  border: 0px;
  outline: 0px;
  padding: 0.03em 0.2em;
  color: black;
  border-radius: 5%;
}
::v-deep .zt-button-fab {
  color: #707070 !important;
  height: 35px;
  width: 35px;
}
::v-deep .zt-icon-minus {
  font-size: 1.5rem !important;
}
::v-deep .zt-icon-plus-2 {
  font-size: 1.5rem !important;
}
.visualizerContainer {
  height: 100%;
}

.bg-viewer {
  background-color: #717171;
}

.bg-top-bar {
  background-color: #c4c4c4;
}

.zoom-buttons-position {
  bottom: 6rem;
  right: 1rem;
}

.zoom-buttons-position-lg {
  bottom: 1rem;
  right: 1rem;
}

.w-left-bar {
  width: 45%;
}

.w-right-bar {
  width: 55%;
}

.angle-page:disabled {
  color: $textSecondary;
}

.visualizerDocument {
  justify-content: center;
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 100%;
  height: 100%;
  transform-origin: top;
  overflow: hidden;
}

.docSizeMd {
  height: 90vw;
  width: 70vw;
}

.docSizeLg {
  height: 40vw;
  width: 30vw;
}

.docSizeXl {
  height: 80%;
  width: 80%;
}

.documentProperties {
  vertical-align: middle;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
  transition: opacity 0.5s ease-in-out;
}

.imgtest {
  width: 80%;
}

.propertiesArrows {
  height: 60vh;
  justify-content: center;
  display: flex;
  align-items: center;
}

.propertiesArrows[disabled] {
  opacity: 0;
}

.propertiesArrows:hover {
  height: 60vh;
  justify-content: center;
  display: flex;
  align-items: center;
  background-color: $textTertiary;
}

.propertiesArrows.icon-LeftChevron {
  font-size: 4em;
}

.propertiesArrows.icon-LeftChevron::before {
  color: $white;
}

.propertiesArrows.icon-RightChevron {
  font-size: 4em;
}

.propertiesArrows.icon-RightChevron::before {
  color: $white;
}

.problemWithImageText {
  color: $white;
  font-size: 1vw;
}

#visualizerDocumentLoading {
  width: 70%;
  max-width: 70%;
  height: 80%;
  display: block;
  position: absolute !important;
  overflow: hidden;
}

::v-deep #loadingForFixing {
  height: 100%;
  transition: opacity 0.5s ease-in-out;
  font-size: 1rem;
  font-weight: 400;
  #loader-1 {
    margin-bottom: 15px;
  }
}

.documentProperties {
}
</style>
